import { joinURL } from 'ufo';
import { createOperationsGenerator } from '@nuxt/image/dist/runtime/utils';

const operationsGenerator = createOperationsGenerator({
  keyMap: {
    resize: 'rs',
    size: 's',
    fit: 'rt',
    width: 'w',
    height: 'h',
    dpr: 'dpr',
    enlarge: 'el',
    extend: 'ex',
    gravity: 'g',
    crop: 'c',
    padding: 'pd',
    trim: 't',
    rotate: 'rot',
    quality: 'q',
    maxBytes: 'mb',
    background: 'bg',
    backgroundAlpha: 'bga',
    blur: 'bl',
    sharpen: 'sh',
    watermark: 'wm',
    preset: 'pr',
    cacheBuster: 'cb',
    stripMetadata: 'sm',
    stripColorProfile: 'scp',
    autoRotate: 'ar',
    filename: 'fn',
    format: 'f',
  },
  formatter: (key, value) => `${key}:${value}`,
});

const defaultModifiers = {
  fit: 'fill',
  width: 0,
  height: 0,
  gravity: 'no',
  enlarge: 1,
  format: 'webp',
};

export function getImage(src, { modifiers, baseURL }, { nuxtContext }) {
  const fileOperations = operationsGenerator({
    ...defaultModifiers,
    ...modifiers,
  });
  const isCdnAsset = /^\/?cms\//.test(src);

  if (!isCdnAsset) {
    if (/^https?:\/\//.test(src)) {
      return {
        url: joinURL(baseURL, '/', fileOperations, '/plain', `/${src}`),
      };
    }
    return { url: joinURL('/', src) };
  }

  let url = '';
  const useSource = /(.)+\.(mp4|svg)$/.test(`${src}`);

  if (useSource) url = joinURL(nuxtContext.$config.fullPath, src);
  else {
    url = joinURL(
      baseURL,
      '/',
      fileOperations,
      '/plain',
      nuxtContext.$config.imagePath,
      `/${src}`
    );
  }

  return { url };
}
